import { Zap } from "lucide-react";
import { DimensionCard } from "./DimensionCard";
import { MetricCard } from "./MetricCard";
import { WorkerTable } from "./WorkerTable";
import type { WorkerStats } from "../api/useWorkerProductivity";

interface ProductivitySectionProps {
  workers: WorkerStats[];
}

export function ProductivitySection({ workers }: ProductivitySectionProps) {
  const totalCompleted = workers.reduce((s, w) => s + w.itemsCompleted, 0);
  const avgCompleted = workers.length > 0 ? totalCompleted / workers.length : 0;
  const avgHandleTime = workers.length > 0
    ? workers.reduce((s, w) => s + w.avgHandleTimeMinutes, 0) / workers.length
    : 0;
  const avgUtilization = workers.length > 0
    ? workers.reduce((s, w) => s + w.utilization, 0) / workers.length
    : 0;

  return (
    <DimensionCard title="Productivity" icon={Zap} colorTheme="purple" id="productivity">
      <div className="grid grid-cols-3 gap-3 mb-4">
        <MetricCard label="Avg Completed/Day" value={Math.round(avgCompleted * 10) / 10} />
        <MetricCard label="Avg Handle Time" value={`${Math.round(avgHandleTime)}m`} />
        <MetricCard
          label="Utilization"
          value={`${Math.round(avgUtilization)}%`}
          health={avgUtilization > 80 ? "green" : avgUtilization >= 60 ? "yellow" : "red"}
        />
      </div>
      <h4 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2">
        Per-Worker Breakdown
      </h4>
      <WorkerTable workers={workers} />
    </DimensionCard>
  );
}
